import React, { Fragment, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getExpertListOptionAction } from "../../../../../services/action/common";
import Buttons from "../../../../utils/buttons/Buttons";
import { unAssignedLeadAction, updateLeadsActionManager } from "../../../../../services/action/manager";
import EditorText from "../../../../utils/text-editor/EditorText";
import UploadRequirements from "./UploadRequirements";
import moment from "moment-timezone";

const AssignExpert = ({ openLead, onClose }) => {
  const { user } = useSelector((state) => state.authenticationReducer);
  const { expertListOption,isUnAssigned} = useSelector((state) => state.commonReducer);
  const { isUpdateLead} = useSelector((state) => state.managerReducer);
  const userType = user?.userType;
  const isManager = userType === "MANAGER" || "ADMIN" || "SUPER_ADMIN" || "OPERATOR";
  const dispatch = useDispatch();
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const getWatch = watch();
  const isInitialized = useRef(false);
  useEffect(() => {
    if (userType && userType !== "client" && userType !== "expert") {
      dispatch(getExpertListOptionAction({ userType }));
    }
  }, [userType, dispatch]);

  const [imageUrls, setImageUrls] = useState([]);

  useEffect(() => {
    if (openLead && !isInitialized.current) {
      setValue("expert", openLead?.expert?._id);
      setValue(
        "expertAmount",
        openLead?.expertAmount < 1 ? "" : openLead?.expertAmount
      );
      // if (openLead?.clientDeadline) {
      //   let dates = new Date(openLead?.clientDeadline);
      //   const formattedDate = dates.toISOString().slice(0, 16);
      //   setValue("clientDeadline", formattedDate);
      // }

      if (openLead?.clientDeadline) {
        const dates = moment(openLead?.clientDeadline).tz("Asia/Kolkata");
        const formattedDate = dates.format("YYYY-MM-DDTHH:mm");
        setValue("clientDeadline", formattedDate);
      }
  
      // Convert expertDeadline to Asia/Kolkata timezone
      if (openLead?.expertDeadline) {
        const dates = moment(openLead?.expertDeadline).tz("Asia/Kolkata");
        const formattedDate = dates.format("YYYY-MM-DDTHH:mm");
        setValue("expertDeadline", formattedDate);
      }
      setValue("requirement",openLead?.requirement)
      setImageUrls(openLead?.document);

      // if (openLead?.expertDeadline) {
      //   let dates = new Date(openLead?.expertDeadline);
      //   const formattedDate = dates.toISOString().slice(0, 16);
      //   setValue("expertDeadline", formattedDate);
      // }
      isInitialized.current = true; // Mark as initialized
    }
  }, [openLead, setValue]);
  const onSubmit = (data) => {
    if (data) {
      data._id = openLead?._id;
      data.orderStatus = "ASSIGNED";
      data.document=imageUrls
      data.expertAmount = data?.expertAmount
        ? parseInt(data?.expertAmount)
        : "";
      dispatch(
        updateLeadsActionManager({
          userType: userType?.toLowerCase(),
          data,
          cb: onClose,
        })
      );
    }
  };


  const unAssigned=()=>{
   dispatch(unAssignedLeadAction({userType:userType?.toLowerCase(),data:{leadId:openLead?._id},cb: onClose,}))
  }
  return (
    <Fragment>
      <form className="form-control">
        <div className="row custom-form generate-lead-form">
          <div className="col-sm-6">
            <label className={errors?.expert && "text-danger"}>
              Expert<span className="text-danger">*</span>
            </label>
            <select
              className="form-control"
              {...register("expert", {
                required: true,
              })}
              // disabled={openLead?.expert && !isManager}
            >
              <option value={""}></option>

              {expertListOption?.map((item, index) => (
                <option
                  selected={getWatch?.expert === item?.value}
                  key={index}
                  value={item?.value}
                >
                  {item?.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-6">
            <label className={errors?.expertDeadline && "text-danger"}>
              Expert Deadline<span className="text-danger">*</span>
            </label>
            <input
              {...register("expertDeadline", {
                required: true,
              })}
              disabled={!isManager}
              min={new Date().toISOString().slice(0, 16)}
              type="datetime-local"
              max={
                getWatch?.clientDeadline &&
                moment(getWatch?.clientDeadline).format("YYYY-MM-DDTHH:mm")
              }
              className="form-control"
            />
          </div>
          <div className="col-sm-6">
            <label className={errors?.expertAmount && "text-danger"}>
              Expert Amount<span className="text-danger">*</span>
            </label>
            <input
              {...register("expertAmount", {
                required: true,
              })}
              type="text"
              disabled={openLead?.expertAmount && !isManager}
              className="form-control"
            />
          </div>
          <div className="col-sm-6">
            <label className={errors?.clientDeadline && "text-danger"}>
              Client Deadline<span className="text-danger">*</span>
            </label>
            <input
              {...register("clientDeadline", {
                required: true,
              })}
              // disabled={true}
              min={new Date().toISOString().slice(0, 16)}
              type="datetime-local"
              className="form-control"
            />
          </div>
          <div className="col-sm-12">
            <label>Requirements</label>
            <EditorText value={getWatch?.requirement} setValue={(value) => setValue("requirement",value)} />
          </div>
          <UploadRequirements
            imageUrls={imageUrls}
            setImageUrls={setImageUrls}
          />
          <div className="col-sm-12 mt-2 text-center">
            
            <Buttons disabled={isUpdateLead} isLoading={isUpdateLead} title={"Assign"} onClick={handleSubmit(onSubmit)} />
            {openLead?.orderStatus!="OPEN" && <Buttons disabled={isUnAssigned} isLoading={isUnAssigned} style={{marginLeft:10}} variant="outlined" title={"Move to Open"} onClick={unAssigned} />}
          </div>
        </div>
      </form>
    </Fragment>
  );
};

export default AssignExpert;
